import { useState } from "react";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export default function LeadForm({ serviceSlug, title = "Get a Free Consultation", dark = true }) {
  const [form, setForm] = useState({ name: "", phone: "", company: "", note: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");
    try {
      await api.post("/leads", { ...form, service_slug: serviceSlug || null });
      setStatus("success");
    } catch (err) {
      setError(formatApiError(err));
      setStatus("error");
    }
  };

  const fieldCls = "w-full bg-[#0B132B] border border-[#1E293B] rounded-md px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-[#F97316] focus:ring-1 focus:ring-[#F97316] transition-colors";

  if (status === "success") {
    return (
      <div className="text-center py-10 animate-fade-up" data-testid="lead-form-success">
        <CheckCircle2 className="w-14 h-14 text-[#10B981] mx-auto mb-4" />
        <h3 className="font-display text-2xl font-bold text-white mb-2">Request Received!</h3>
        <p className="text-slate-300 text-sm max-w-sm mx-auto">
          Thank you, {form.name.split(" ")[0]}. Our agent will reach out within <strong className="text-[#F97316]">1–2 hours</strong> during business hours.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="lead-form">
      <h3 className="font-display text-2xl font-bold text-white tracking-wide">{title}</h3>
      <div className="grid sm:grid-cols-2 gap-4">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Full Name *" className={fieldCls} data-testid="lead-form-name" />
        <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
          placeholder="Phone Number *" type="tel" className={fieldCls} data-testid="lead-form-phone" />
      </div>
      <input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })}
        placeholder="Company Name / USDOT#" className={fieldCls} data-testid="lead-form-company" />
      <textarea value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })}
        placeholder="How can we help? (service needed, deadline, questions...)" rows={4}
        className={fieldCls} data-testid="lead-form-note" />
      {status === "error" && (
        <p className="text-sm text-red-400" data-testid="lead-form-error">{error}</p>
      )}
      <button type="submit" disabled={status === "loading"} data-testid="lead-form-submit"
        className="w-full bg-[#F97316] hover:bg-[#EA580C] disabled:opacity-60 text-[#0B132B] font-bold text-sm px-6 py-3.5 rounded-md transition-colors duration-200 flex items-center justify-center gap-2">
        {status === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        {status === "loading" ? "Sending..." : "Request Free Consultation"}
      </button>
      <p className="text-xs text-slate-500 text-center">No spam, no obligation. An agent responds within 1–2 business hours.</p>
    </form>
  );
}
